import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { createContext } from "react";

const FirebaseContext: any = createContext(null);

const config: any = {
  apiKey: "AIzaSyA1qnxZJsUzdomZRK9sG0Bkz7Cv_I9xPPk",
  authDomain: "thaihealth-10b93.firebaseapp.com",
  databaseURL:
    "https://thaihealth-10b93-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "thaihealth-10b93",
  storageBucket: "thaihealth-10b93.appspot.com",
  messagingSenderId: "213932167997",
  appId: "1:213932167997:web:f3f1e6b4a678bbe6d56b54",
};

const FirebaseProvider = ({ children }: any) => {
  const app = initializeApp(config);
  const db = getDatabase(app);

  return (
    <FirebaseContext.Provider value={db}>{children}</FirebaseContext.Provider>
  );
};

export { FirebaseProvider, FirebaseContext };

const StorageContext: any = createContext(null);

const StorageProvider = ({ children }: any) => {
  const app = initializeApp(config);
  const storage = getStorage(app);

  return (
    <StorageContext.Provider value={storage}>
      {children}
    </StorageContext.Provider>
  );
};

export { StorageProvider, StorageContext };
